"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutoForceDeepLinkHook = void 0;
class AutoForceDeepLinkHook {
    constructor(props) {
        const { userAgent } = props;
        this._needForceDeepLink = this._getNeedForceDeepLink(userAgent);
    }
    onActive(oneLink) {
        if (this._needForceDeepLink) {
            oneLink.params.forceDeepLink = true;
        }
    }
    _getNeedForceDeepLink(userAgent) {
        if (!userAgent.includes('AppleWebKit')) {
            return true;
        }
        return (/Instagram/i.test(userAgent) ||
            /Messenger/i.test(userAgent) ||
            /FBAN|FBAV/i.test(userAgent) ||
            /Snapchat/i.test(userAgent) ||
            /Discord/i.test(userAgent) ||
            /BytedanceWebview/i.test(userAgent) ||
            /Lark/i.test(userAgent));
    }
}
exports.AutoForceDeepLinkHook = AutoForceDeepLinkHook;
